@layer module {
.select-payment-method-dropdown-wrapper {
            width: 100%;
    }
} // layer module
